import { render, staticRenderFns } from "./ChatQuickReplyPicker.vue?vue&type=template&id=07b71f50&scoped=true"
import script from "./ChatQuickReplyPicker.vue?vue&type=script&lang=js"
export * from "./ChatQuickReplyPicker.vue?vue&type=script&lang=js"
import style0 from "./ChatQuickReplyPicker.vue?vue&type=style&index=0&id=07b71f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b71f50",
  null
  
)

export default component.exports